module.exports = __webpack_public_path__ + "static/media/timeout-tip.03bb1dfb.mp3";